import { RouteConfig } from "vue-router";
import { safeImport } from "@/utils/SafeImport";

const routes: RouteConfig[] = [
  {
    path: "/files/:id/download",
    name: "file_download",
    component: safeImport(
      () =>
        import(
          /* webpackChunkName: "route.file.download" */ "../views/Download.vue"
        )
    ),
    meta: {
      auth: true,
    },
  },
];

export default routes;
